import { render, staticRenderFns } from "./inspectionTemplateList.vue?vue&type=template&id=1a461d2e&"
import script from "./inspectionTemplateList.vue?vue&type=script&lang=ts&"
export * from "./inspectionTemplateList.vue?vue&type=script&lang=ts&"
import style0 from "./inspectionTemplateList.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports